<template>
  <div class="wrap" v-loading="loading">
    <div class="place">
      <router-link class="link" to="./">首页</router-link>
      <div class="division">/</div>
      <div class="active">订单明细</div>
    </div>
    <div class="master" ref="master">
        <el-descriptions class="margin-top" title="单据信息" :column="2" size="medium">
          <template slot="extra">
            <el-button type="primary" size="mini" @click="printLabel()"
        >打印货品标签</el-button
        >
        <el-button type="primary" size="mini" @click="printPack()"
          >打印外包装标签</el-button
        >
          </template>
          <el-descriptions-item label="单号">{{ master.PO_code }}</el-descriptions-item>
          <el-descriptions-item label="日期">{{ master.po_date }}</el-descriptions-item>
          <el-descriptions-item label="创建人">{{ master.CreateBy }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ master.CreateOn }}</el-descriptions-item>
          <el-descriptions-item label="审核人">{{ master.ApprovedBy }}</el-descriptions-item>
          <el-descriptions-item label="审核时间">{{ master.ApprovedOn }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ master.Status }}</el-descriptions-item>
        </el-descriptions>
    </div>
    <template>
      <el-table 
        :data="tableData"
        :style="contentStyleObj"
        fit
        show-summary
        :summary-method="getSummaries">
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="item_code" label="货品编码"> </el-table-column>
        <el-table-column prop="codeForSupp" label="工厂编码" width="200"></el-table-column>
        <el-table-column prop="item_name_cn" label="中文名称" width="200"></el-table-column>
        <el-table-column prop="carMod" label="车型" width="150"></el-table-column>
        <el-table-column prop="item_qty" label="数量" width="80"></el-table-column>
        <el-table-column prop="unit" label="单位" width="80"></el-table-column>
        <el-table-column prop="cat1" label="品牌" width="100"></el-table-column>
        <el-table-column prop="issue_qty" label="发货数量" width="100"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              v-if="status == 'A'"
              size="mini"
              @click="updateIssue(scope.$index, scope.row)"
              >修改数量</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="printItem(scope.$index, scope.row)"
              >打印</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>

<script>
export default {
  name: "order_detail",
  props:['param'],
  data() {
    return {
      contentStyleObj: {
        height: "",
        "min-width": "1400px",
        overflow: "auto",
      },
      params: this.$route.params,
      tableData: [],
      status: "",
      master: [],
      loading: false
    };
  },
  async created() {
    this.loading = true;
    await this.getData();
    this.loading = false;
  },
  mounted(){
    this.getHeight();
  },
  methods: {
    async getData() {
      // let params = this.params;
      let params = JSON.parse(this.param);
      let res = await this.$Http.getOrderDetail(params);
      if (res.code == 0) {
        this.tableData = res.data.data;
        this.status = res.data.status;
        this.master = res.data.master;
      } else {
        this.$message.error(res.msg);
      }
    },
    /**
     * 修改发货数量
     */
    updateIssue(index, row) {
      this.$prompt("输入数量", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\d+$/,
        inputErrorMessage: "只能输入数字",
      })
        .then(async ({ value }) => {
          let params = {
            value,
            dept_id: row.dept_id,
            PO_code: row.PO_code,
            item_code: row.item_code,
          };
          this.loading = true;
          let res = await this.$Http.updateIssue(params);
          if (res.code == 0) {
            await this.getData();
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false;
        })
        .catch(() => {});
    },
    printItem(index, row) {
      // console.log(index, row);
      let params = JSON.parse(this.param);
      let url = this.GLOBAL.basic_url + 'sr_scm/printItem?dept_id='+params.dept_id+'&PO_code='+params.PO_code+'&item_code='+row.item_code;
      window.open(url);
    },
    //设置窗口高度
    getHeight() {
      this.contentStyleObj.height = window.innerHeight - 120 - 70 - 15 - this.$refs.master.offsetHeight + "px";
    },
    /**
     * 确认订单
     */
    confirm() {
      this.$confirm("确认之后无法再更改！是否继续操作？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // let params = this.params;
          let params = JSON.parse(this.param);
          let res = await this.$Http.orderConfirm(params);
          if (res.code == 0) {
            this.$message({
              message: "确认成功",
              type: "success",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //合计方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property == "item_qty") {
          const values = data.map((item) => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
        if (column.property == "issue_qty") {
          const values = data.map((item) => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      return sums;
    },
    /**
     * 打印货品标签
     */
    printLabel(){
      // window.location.href="https://www.baidu.com";
      let params = JSON.parse(this.param);
      let url = this.GLOBAL.basic_url + 'sr_scm/printLabel?dept_id='+params.dept_id+'&PO_code='+params.PO_code;
      window.open(url);
    },
    /**
     * 打印外箱大标签
     */
    printPack(){
      let params = JSON.parse(this.param);
      let url = this.GLOBAL.basic_url + 'sr_scm/printPack?dept_id='+params.dept_id+'&PO_code='+params.PO_code;
      window.open(url);
    }
  },
};
</script>

<style scoped>
.wrap {
  padding: 0 20px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
}
.place {
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.division {
  padding: 0 5px;
  color: #c0c4cc;
}
.btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
}
.el-table::before{
  height: 0 !important;
}
</style>